import { FunctionComponent, useEffect, useState } from 'react';
import { ChipStack, useMedia,  useConfigSlice,
  useBonusBalanceConfig, 
  useSettingsSlice} from '@pp/core';
import styles from './navControls.module.css';
import { useNetPositionConnected } from '@pp/core/src/hooks/useNetPositionConnected';

export const NavControlsConnected: FunctionComponent = () => {
  const [hideNavControls, sethideNavControls] = useState(true);
  const isInFullscreen = useSettingsSlice.getIsInFullscreen();
  const compliance = useConfigSlice.compliance();
  const displayBonusBalance = useBonusBalanceConfig();
  const net = useNetPositionConnected();
  const isGameFooterInWideMode = useMedia('(min-width: 620px)');
  let isGameFooterExtended : boolean | undefined = false;
  if(isGameFooterInWideMode) {
    isGameFooterExtended = compliance?.showSessionTimer || compliance?.showSessionId; 
  } else {
    isGameFooterExtended = compliance?.showSessionTimer || displayBonusBalance || net !== undefined || compliance?.showSessionId; 
  }
  
  useEffect(() => {
    const handleChange = () => {
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      sethideNavControls(isGameFooterExtended ? height >= 370 : height >= 360);
    }
    handleChange();
    window.addEventListener('resize', handleChange);
    return () => {
      window.removeEventListener('resize', handleChange);
    };
}, [isInFullscreen]);


  if(hideNavControls){
    return null;
  }

  return (
    <div className={`${styles.navControls}`}>
      <ChipStack.Clip stacked="horizontal" />
    </div>
  );
};
